import { CountryOut, UserOut } from "@/api";
import { Country } from "@/framework/types/Country";


export class CountryMapper {
    static fromApi(dto: CountryOut): Country {
        return {
            id: dto.id ?? 0,
            name: dto.code ?? "",
            shortName: dto.country_short_name ?? undefined,
            timezone: dto.timezone ?? undefined,
            currency: dto.currency ?? undefined,
            phoneCode: dto.phone_country_code ?? undefined,
            phoneLength: dto.phone_number_length ?? undefined,
            phonePattern: dto.phone_number_pattern ?? undefined,
            phonePlaceholder: dto.phone_placeholder ?? undefined,
            phoneExample: dto.phone_example ?? undefined,
        }
    }
}